import { FormattedMessage } from 'react-intl';

export const BirthdayTitle = () => (
  <span data-testid="date-of-birth-vp-title">
    <FormattedMessage id="vp.dateOfBirth.title" />
  </span>
);